import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMaterialReactTable,
} from 'material-react-table';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HeadingGroup } from '@/components/ui/heading-group';
// import { StatusIcon } from '@/components/ui/status-icon';
import { useCurrentGroup } from '@/hooks/use-current-group';
import { useUnitUrlComposer } from '@/hooks/use-unit-url-composer';
import { useUnits } from '@/hooks/use-units';
import { HeadingGroupContainerLayout } from '@/layouts/heading-group-container-layout';
import {
  composeTableOptions,
  getEntityRowId,
  getFilteredSelectedRows,
} from '@/table';
import { Unit } from '@/types/unit';
import { SelectedUnitsActionBar } from './selected-units-action-bar';

const columns: MRT_ColumnDef<Unit>[] = [
  {
    accessorKey: 'unitName',
    header: 'Unit Name',
    grow: true,
    size: 150,
    Cell: ({ renderedCellValue, row }) => {
      const composeUnitUrl = useUnitUrlComposer();
      return (
        <Link to={composeUnitUrl(row.original.id)}>{renderedCellValue}</Link>
      );
    },
  },
  {
    accessorKey: 'id',
    header: 'Unit #',
    size: 100,
  },
  {
    id: 'deviceCount',
    accessorFn: ({ devices }) => devices.length,
    header: 'No. of Devices',
    size: 150,
    Cell: ({ renderedCellValue }) =>
      `${renderedCellValue} ${renderedCellValue === 1 ? 'devices' : 'devices'}`,
  },
  // {
  //   id: 'setupCompleted',
  //   accessorFn: ({ devices }) => {
  //     if (devices.length === 0) {
  //       return undefined;
  //     }
  //     return devices.every(({ setupCompleted }) => setupCompleted) ? 1 : -1;
  //   },
  //   sortingFn: (
  //     { renderValue: renderValueA },
  //     { renderValue: renderValueB },
  //   ) => {
  //     const a = renderValueA('setupCompleted');
  //     const b = renderValueB('setupCompleted');
  //     if (typeof a === 'number' && typeof b === 'number') {
  //       return a - b;
  //     }
  //     return 0;
  //   },
  //   header: 'Devices Ready',
  //   grow: false,
  //   size: 170,
  //   Cell: ({ renderedCellValue }) => {
  //     if (typeof renderedCellValue !== 'number') {
  //       return null;
  //     }
  //     return (
  //       <StatusIcon variant={renderedCellValue > 0 ? 'success' : 'warning'} />
  //     );
  //   },
  // },
];

export default function AssociateUnitsPage() {
  const { data: group } = useCurrentGroup();
  const { data: units, isLoading: isLoadingUnits, update } = useUnits();
  const [applyUpdate] = update;
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({}); //ts type available
  const table = useMaterialReactTable({
    ...composeTableOptions<Unit>({ enableRowSelection: true }),
    columns,
    enableColumnResizing: true,
    data: units.filter((unit) => !unit.group),
    getRowId: getEntityRowId,
    onRowSelectionChange: setRowSelection,
    state: {
      rowSelection,
      isLoading: isLoadingUnits,
      ...(isLoadingUnits
        ? {
            pagination: {
              pageIndex: 0,
              pageSize: 1,
            },
          }
        : {}),
    },
    localization: {
      noRecordsToDisplay:
        'No unassigned units available to associate with this group',
    },
  });

  const handleLinkUnits = async () => {
    // If we are not executing in the context of a group, do nothing
    if (!group) {
      return;
    }

    // Get then reset the row selection, as the table data is changing when we do the update
    const selectedUnits = getFilteredSelectedRows(table);
    table.resetRowSelection();

    const updated = selectedUnits.map((unit) => ({
      ...unit,
      groupId: group?.id,
    }));

    // TODO: Toast results
    await Promise.all(updated.map((unit) => applyUpdate(unit)));
  };

  return (
    <>
      <HeadingGroupContainerLayout>
        <HeadingGroup
          subtitlePrefix="Add existing units to Group"
          title={group?.groupName ?? ''}
        />
      </HeadingGroupContainerLayout>

      <SelectedUnitsActionBar
        numberOfSelectedUnits={getFilteredSelectedRows(table).length}
        onLinkUnitsClick={handleLinkUnits}
      />
      <MaterialReactTable table={table} />
    </>
  );
}
